export default __webpack_public_path__ + "static/10e480be9ae0a9a623682ef516366be8.jpg";